import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useDownloader from "react-use-downloader";

export default function ScriptAccordion({ scrollToRow, tableOfContent }) {
  const [expanded, setExpanded] = React.useState(false);
  const { download } = useDownloader();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleDownloadScript = () => {
    const fileName = "Pally - Master Teacher Script.pdf";

    download(
      "https://res.cloudinary.com/principally/image/upload/v1687243054/Files/Principally_-_Master_Teacher_Script_NO_AUTHORS_.docx_g1qtff.pdf",

      fileName
    );
  };

  return (
    <div className="accordion-section">
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className="accordion-heading">
            <Typography sx={{ fontWeight: "bold" }}>
              Table of Contents
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className="accordion-details">
          <Typography className="content-name" onClick={handleDownloadScript}>
            To reference the original template provided, you may download the
            Master Script by clicking here.
          </Typography>
          {tableOfContent.map((content, key) => (
            <Typography
              key={key}
              className="content-name"
              onClick={() => scrollToRow(key)}
            >
              {content}
            </Typography>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
